import { Exception } from 'src/app/core/logic/exception';

export class NoteNotFoundException extends Exception<never> {
  constructor() {
    super('Note non trouvée');
  }
}
